import React from 'react';
import './style.css';

const RatingCard = ({ name, rating, align }) => {
  return (
    <>
     
    <div className={`rating-card-wrapper ${align}`}>
        
      <div className="rating-card">
        <div className="user-info">
          <div className="avatar-review" />
          <div className="name">{name}</div>
        </div>
        <div className="stars">
          {[...Array(5)].map((_, i) => (
            <span key={i} className={i < rating ? 'filled' : ''}>★</span>
          ))}
        </div>
        <div className="placeholder-line short" />
        <div className="placeholder-line" />
  
      </div>

    </div>
    </>
  );
};

const RatingSection = () => {
  return (
    <div>
      <RatingCard name="Alice Johnson" rating={5} align="left" />
      <RatingCard name="Bob Smith" rating={5} align="right" />
      <RatingCard name="Charlie Davis" rating={4} align="left" />
    </div>
  );
};

export default RatingSection;
